import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  shadow?: boolean
  vertical?: boolean
}

const SummaryItemList = ({ children, shadow = false, vertical = false }: Props) => {
  return (
    <div
      className={clsx(
        'flex overflow-hidden rounded-xl',
        shadow && 'shadow-300',
        vertical && 'flex-col'
      )}
    >
      {children}
    </div>
  )
}

export default SummaryItemList
